export default "https://cdn-static.gokick.com/assets/c0e4f86ff5da21e4b09546702d214e718bb56dad/images/tangerine-flavor.f6541269ddee78b301b9a4e8b180b6f6.png";